import { ajax as rxAjax } from 'rxjs/observable/dom/ajax'

import { getDefaultHeaders } from './httpUtils'

const mergeWithDefaultHeaders = (headers) => ({
  ...getDefaultHeaders(),
  ...headers,
})

export const ajax = (settings) => {
  // careful, we are not checking same-origin
  settings.headers = mergeWithDefaultHeaders(settings.headers)
  return rxAjax(settings)
}

const withJson = (headers) => ({
  'Content-Type': 'application/json',
  ...headers,
})

export const post = (url, body, headers, responseType = 'json') =>
  ajax({
    url,
    body,
    headers: withJson(headers),
    method: 'POST',
    responseType,
  })

export const put = (url, body, headers) =>
  ajax({
    url,
    body,
    headers: withJson(headers),
    method: 'PUT',
  })

export const get = (url, responseType = 'json') =>
  ajax({ url, responseType, method: 'GET' }).map((x) => x.response)

export const deleteRest = (url, body = {}, headers = {}) =>
  ajax({
    url,
    body,
    headers,
    method: 'DELETE',
  })

export const postWithoutBody = (url, body, headers, responseType = 'json') =>
  ajax({
    url,
    body,
    headers,
    method: 'POST',
    responseType,
  })

export const putWithoutBody = (url, body, headers) =>
  ajax({
    url,
    body,
    headers,
    method: 'PUT',
  })
